export default "__VITE_ASSET__ec52f04f__"